import React, {PureComponent} from 'react';
import './ProductSearch.scss';

import ResultList from './ResultList';
import Pagination from './Pagination';

const flatten = list => (
    list.reduce((a, b) => a.concat(Array.isArray(b) ? flatten(b) : b), [])
)

class ProductSearch extends PureComponent {
    state = {
        posts: [],
        offset: 0,
        searchText: [],
        areaSelect: '',
        categorySelect: '',
        filterID: 0,
        sortColumnField: '',
        pageNumber: 0
    }

    async componentDidMount(){
        const res = await fetch('/wp-json/ssf/search-products');
        const posts = JSON.parse(await res.json());

        this.setState({ posts });
    }

    handlePaginationClick = data => {
        const selected = data.selected;
        const offset = Math.ceil(selected * this.props.postsPerPage);

        this.setState({
            offset,
            pageNumber: data.selected
        });
    };

    handleTextSearchClick = () => {
        let { searchKeywords } = this.props;

        if(!this.searchValue) {
            this.setState({
                offset: 0,
                pageNumber: 0,
                searchText: "",
            })

            return;
        }

        let value = this.searchValue.toLowerCase();

        let synonyms = searchKeywords.split("\n");
        synonyms = synonyms.map(word => word.split("->"))
        synonyms = synonyms.map(word => word.map(item => item.trim().toLowerCase()))

        let synonymsObject = synonyms.reduce((acc, curr) => {
            const existingValues = acc[curr[0]] || []
            acc[curr[0]] = [...existingValues, curr[1]];
            return acc
        }, {})

        value = synonymsObject[value] || [value]

        this.setState({
            offset: 0,
            pageNumber: 0,
            searchText: value,
        })

    }

    handleSelect = filterField => e => {
        this.setState({
            pageNumber: 0,
            offset: 0,
            [filterField]: e.target.value,
        });
    }

    handleFilter = filterID => {
        const isSelected = this.state.filterID === filterID;

        if(isSelected) return;

        this.setState({
            pageNumber: 0,
            offset: 0,
            filterID,
        });
    }

    handleSortColumn = sortColumnField => {
        this.setState({
            pageNumber: 0,
            offset: 0,
            sortColumnField,
        })
    }

    generateAreaTypes = posts => {
        const areasWithIndentation = posts.map(item => {
            const mainLevelItem = {
                label: item.label,
                value: item.label,
            };
            let subAreas = item.subAreas || []

            subAreas.sort(function(a, b) {
                var textA = a.label;
                var textB = b.label;
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });

            const subLevelItems = subAreas.map(subItem => ({
                label: `&nbsp;&nbsp; ${subItem.label}`,
                value: subItem.label,
            }))

            return [
                mainLevelItem,
                ...subLevelItems,
            ]
        })

        return flatten(areasWithIndentation)
    }

    buildServiceAreaTree = items => {
        if (!items || !items.length) {
            return [];
        }

        return items.map(item => {
            let categories = [];
            if(item.subAreas) {
                categories = (item.subAreas).map(x => x.categories.split(";"))
                categories = flatten(categories)
            }

            if (item.categories) {
                categories = item.categories.split(";")
            }

            return {
                label: item.label,
                categories: categories,
                intro: item.intro,
                children: this.buildServiceAreaTree(item.subAreas),
            }
        })
    }

    flattenServiceAreaTree = items => {
        return items.reduce((acc, curr) => {
            return [
                ...acc,
                curr,
                ...curr.children,
            ]
        }, [])
    }

    generateCategoryTypes = (posts, areaSelect) => {
        let categoryTypes = [];
        let introText = '';

        let reformattedServiceAreas = this.buildServiceAreaTree(posts);
        reformattedServiceAreas = this.flattenServiceAreaTree(reformattedServiceAreas);

        if(areaSelect){
            let selectedArea = reformattedServiceAreas.filter(x => x.label === areaSelect)[0];
            introText = selectedArea.intro;
            categoryTypes = selectedArea.categories;
        } else {
            categoryTypes = reformattedServiceAreas.reduce((total, area) => {
                return total.concat(area.categories);
            }, [])
        }

        categoryTypes = categoryTypes.filter(item => item !== '')
        categoryTypes = [...new Set(categoryTypes.map(item => item.trim()))].sort();

        return {
            categoryTypes,
            introText
        }
    }

    excludePosts = (exclude, posts) => {
        let {
            excludedAreas,
            excludedProductTypes
        } = exclude;

        let filteredPosts = [...posts];

        excludedAreas = excludedAreas.split("\n");
        excludedAreas = excludedAreas.filter(Boolean);
        excludedAreas = excludedAreas.map(item => item.trim());
        for(let i = 0; i < excludedAreas.length; i++){
            filteredPosts = filteredPosts.filter(post => {
                const serviceAreaProductType = post.ServiceArea;
                return excludedAreas[i] !== serviceAreaProductType;
            })
        }

        excludedProductTypes = excludedProductTypes.split("\n");
        excludedProductTypes = excludedProductTypes.map(item => item.trim());
        for(let i = 0; i < excludedProductTypes.length; i++){
            filteredPosts = filteredPosts.filter(post => {
                const serviceAreaProductType = post.ServiceAreaProductName;
                return excludedProductTypes[i] !== serviceAreaProductType;
            })
        }

        filteredPosts = filteredPosts.filter(x => {
            return (
                x.ServiceTypeId === 3
                || x.ServiceTypeId === 1 && (x.ServiceArea === "Inbrottslarm" && x.ServiceAreaProductName === "Anläggarfirma")
                || x.ServiceTypeId === 1 && (x.ServiceArea === "Inbrottslarm" && x.ServiceAreaProductName === "Anläggarfirma Inbrottslarm")
                || x.ServiceTypeId === 1 && (x.ServiceArea === "Larmförmedling" && x.ServiceAreaProductName === "Larmcentral")
                || x.ServiceTypeId === 1 && (x.ServiceArea.includes("Lås") && x.ServiceAreaProductName === "Anläggarfirma, filial - Låsanläggningar")
                || x.ServiceTypeId === 1 && (x.ServiceArea.includes("Lås") && x.ServiceAreaProductName === "Anläggarfirma Låsanläggningar")
                || x.ServiceTypeId === 1 && (x.ServiceArea === "CCTV" && x.ServiceAreaProductName === "Anläggarfirma CCTV")
                || x.ServiceTypeId === 1 && (x.ServiceArea === "Cybersäkerhet")
            )
        })


        filteredPosts = filteredPosts.filter(x => {
            let expirationDate = new Date(x.ValidTo)
            let now = new Date();

            return expirationDate > now
        })

        filteredPosts = filteredPosts.filter(x => {
            if(!x.RevokeDate) return true;

            return new Date(x.RevokeDate) > now
        })

        return filteredPosts;
    }

    filterPosts = (filters, posts) => {
        const {
            areaSelect,
            categorySelect,
            categoryTypes,
            filterID,
            searchText,
            excludedAreas,
            excludedProductTypes,
        } = filters;

        let filteredPosts = [...posts];

        if(searchText && searchText.length){
            let postsMultiDimensional = searchText.map(searchValue => {
                return posts.filter(post => {
                    let searchTextLowerCase = searchValue.toLowerCase();

                    let certificateOwnerLowerCase = post.CertificateOwner.toLowerCase();
                    let serviceAreaNameLowerCase = post.ServiceAreaProductName.toLowerCase();
                    let productDesignationLowerCase = post.ProductDesignation.toLowerCase();
                    let classLowerCase = post.Class.toLowerCase();

                    return (
                        certificateOwnerLowerCase.includes(searchTextLowerCase)
                        || serviceAreaNameLowerCase.includes(searchTextLowerCase)
                        || productDesignationLowerCase.includes(searchTextLowerCase)
                        || classLowerCase.includes(searchTextLowerCase)
                    )
                });
            })

            filteredPosts = flatten(postsMultiDimensional)
        }

        if(areaSelect){
            let postsMultiDimensional = categoryTypes.map(categoryType =>
                filteredPosts.filter(post => post.ServiceAreaProductName === categoryType)
            )
            filteredPosts = flatten(postsMultiDimensional)
        }

        if(categorySelect){
            filteredPosts = filteredPosts.filter(post => post.ServiceAreaProductName === categorySelect);
        }

        let filterOptions = [
            {
                title: "Alla",
                serviceId: 0,
                postAmount: filteredPosts.length
            },
            {
                title: "Företag",
                serviceId: 1,
                postAmount: filteredPosts.filter(post => post.ServiceTypeId === 1).length
            },
            {
                title: "Produkter",
                serviceId: 3,
                postAmount: filteredPosts.filter(post => post.ServiceTypeId === 3).length
            }
        ]

        if(filterID && filterID !== 0){
            filteredPosts = filteredPosts.filter(post => post.ServiceTypeId === filterID);
        }

        return {
            filteredPosts,
            filterOptions
        }
    }

    sortColumn = (sortColumnField, posts) => (
        [...posts].sort((a,b) => {
            let first = sortColumnField && a[sortColumnField].toLowerCase();
            let second = sortColumnField && b[sortColumnField].toLowerCase();

            return first.localeCompare(second);
        })
    )

    render(){
        const {
            posts,
            searchText,
            areaSelect,
            categorySelect,
            filterID,
            offset,
            sortColumnField,
            pageNumber,
        } = this.state;
        const {
            postsPerPage,
            columnTitleItems,
            serviceAreas,
            introPermanent,
            searchKeywords,
            excludedAreas,
            excludedProductTypes,
        } = this.props;

        let areaTypes = this.generateAreaTypes(serviceAreas, excludedAreas);

        let categoryTypesObject = this.generateCategoryTypes(serviceAreas, areaSelect);
        let categoryTypes = categoryTypesObject.categoryTypes;

        let introText = categoryTypesObject.introText;

        let excludedPosts = this.excludePosts({
            excludedAreas,
            excludedProductTypes
        }, posts);

        let { filterOptions, filteredPosts } = this.filterPosts({
            searchText,
            areaSelect,
            categorySelect,
            categoryTypes,
            filterID,
            searchKeywords,
        }, excludedPosts);

        filteredPosts = this.sortColumn(sortColumnField, filteredPosts);
        const pageCount = Math.ceil(filteredPosts.length / postsPerPage);
        filteredPosts = filteredPosts.slice(offset, offset + postsPerPage);

        return (
            <div className="ProductSearch">
                <div className="ProductSearch__Wrapper">
                    <div className="ProductSearch__Container">
                        <h3 className="ProductSearch__Title">{'Ange sökord'}</h3>
                        <div className="ProductSearch__Search-Text">
                            <input
                                className="ProductSearch__Search-Text-Input"
                                type="text"
                                onChange={(e) => this.searchValue = e.currentTarget.value}
                            />
                            <input
                                type="submit"
                                value={'Sök'}
                                onClick={this.handleTextSearchClick}
                                className="ProductSearch__Button"
                            />
                        </div>
                        <div className="ProductSearch__Options">
                            <div className="ProductSearch__Option">
                                <h3 className="ProductSearch__Title">{"Område"}</h3>
                                <select
                                    className="ProductSearch__Select ProductSearch__Select--Area"
                                    onChange={this.handleSelect('areaSelect')}
                                    value={areaSelect}
                                >
                                    <option value={''}>{'Alla'}</option>
                                    {areaTypes && areaTypes.map((item, index) =>
                                        <option key={index} value={item.value}
                                        dangerouslySetInnerHTML={{ __html: item.label }}/>
                                    )}
                                </select>
                            </div>
                            <div className="ProductSearch__Option">
                                <h3 className="ProductSearch__Title">{"Kategori"}</h3>
                                <select
                                    className="ProductSearch__Select ProductSearch__Select--Category"
                                    value={categorySelect}
                                    onChange={this.handleSelect('categorySelect')}
                                >
                                    <option value={''}>{'Alla'}</option>
                                    {categoryTypes && categoryTypes.map((item, index) =>
                                        <option key={index} value={item}>{item}</option>
                                    )}
                                </select>
                            </div>
                        </div>
                        <p
                            className="ProductSearch__Description"
                            dangerouslySetInnerHTML={{ __html: introText }}
                        />
                        <p
                            className="ProductSearch__Description"
                            dangerouslySetInnerHTML={{ __html: introPermanent }}
                        />
                        <span className="ProductSearch__Count">{filterOptions[0].postAmount + " träffar"}</span>
                    </div>

                    <div className="ProductSearch__Filter">
                        {filterOptions && filterOptions.map((option, index) =>
                            <label className="ProductSearch__Filter-Label" key={index}>
                                <input
                                    className="ProductSearch__Filter-Input"
                                    type="radio"
                                    name="filter"
                                    value={option.title}
                                    checked={filterID === option.serviceId}
                                    onChange={() => this.handleFilter(option.serviceId)}
                                />{option.title} <span className="ProductSearch__Filter-Input--Result">({option.postAmount})</span>
                                <span className="ProductSearch__Filter-Span">
                                    {option.title} <span className="ProductSearch__Filter-Input--Result">({option.postAmount})</span>
                                </span>
                            </label>
                        )}
                    </div>

                    { filteredPosts.length !== 0 &&
                        <ResultList
                            posts={filteredPosts}
                            onSort={this.handleSortColumn}
                            columnTitleItems={columnTitleItems}
                        />
                    }

                    { pageCount > 1 &&
                        <Pagination
                            pageCount={pageCount}
                            pageNumber={pageNumber}
                            onPageChangeClick={this.handlePaginationClick}
                        />
                    }
                </div>
            </div>
        )
    }
}

ProductSearch.propTypes = {
    // serviceAreas: PropTypes.array,
    // introPermanent: PropTypes.string,
    // searchKeywords: PropTypes.string,
    // excludedAreas: PropTypes.string,
    // excludedProductTypes: PropTypes.string
}

ProductSearch.defaultProps = {
    serviceAreas: [],
    postsPerPage: 20,
    introPermanent: '',
    searchKeywords: '',
    excludedAreas: '',
    excludedProductTypes: '',
    columnTitleItems: [
        {
            title: "Innehavare",
            sort: "CertificateOwner"
        },
        {
            title: "Typ",
            sort: "ServiceAreaProductName"
        },
        {
            title: "Beteckning",
            sort: "ServiceArea"
        },
        {
            title: "Klass",
            sort: "Class"
        }
    ]
}

export default ProductSearch;
